import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import { RadioButton } from "primereact/radiobutton";
import InvoicesGrid from "./InvoicesGrid";
import { ReactComponent as Payments } from "../../../assets/icons/payments.svg";
import { ReactComponent as ArticleShortcut } from "../../../assets/icons/article_shortcut.svg";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import "./Invoices.scss";
import {
  setGridCurrentPageInvoice,
  setIsAddToConsolidatedInvoicePopupOpen,
  setNumberOfRowsPerPage,
  setGridCurrentPageConsolidatedInvoice,
  resetConsolidatedFilterData,
  resetFilterData,
  createConsolidatedInvoice,
  setSelectedItems,
  setActiveTab,
  getPaymentClearance,
  setFilterDataField,
  getConsolidatedInvoices,
  setConsolidatedFilterDataField,
  setInvoices,
  setConsolidatedInvoices,
  getAllConsolidatedInvoices,
} from "src/redux/slices/invoiceSlice";
import InvoicesDetailsPopup from "./InvoicesDetailsPopup";
import { Box } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import ConsolidatedInvoicesGrid from "./ConsolidatedInvoice/ConsolidatedInvoicesGrid";
import { Add } from "@mui/icons-material";
import AddToConsolidatedInvoicePopup from "./ConsolidatedInvoice/AddToConsolidatedInvoicePopup";
import { NUMBER_OF_ROWS_PER_PAGE } from "src/resources/constant";
import { toast } from "react-toastify";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";
import { useNavigate } from "react-router";
import { RoutePaths } from "src/resources/enum";
import useOnPageLeave from "src/hooks/useOnPageLeave";
import { TabMenu } from "primereact/tabmenu";
import InvoicesFilter from "./InvoicesFilter";
import PaymentClearancePopup from "./PaymentClearance";
import {
  getInvoiceStatusOptions,
  getBuildingsForInvoices,
} from "src/redux/slices/lookupSlice";
import ShowHistoricalData from "src/components/ShowHistoricalData/ShowHistoricalData";
import { setChangeHistoricalDataSource } from "src/redux/slices/sharedSlice";
import { toCamel } from "src/utils/helpers";
interface ConsolidatedInvoice {
  invoiceId: string;
  invoiceNumber: string;
}
const Invoices = () => {
  const [allConsolidatedInvoices, setAllConsolidatedInvoices] = useState<
    ConsolidatedInvoice[]
  >([]);
  const activeTab = useSelector((state: any) => state.invoices.activeTab);
  const invoices = useSelector((state: any) => state.invoices);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation(["common", "invoice"]);
  const { showHistoricalData } = useSelector((state: any) =>
    activeTab === 0
      ? state.invoices.filterData
      : state.invoices.consolidatedFilterData
  );
  const { showHistoricalDataChangeSource } = useSelector(
    (state: any) => state.shared
  );
  const {
    isAddToConsolidatedInvoicePopupOpen,
    isInvoicesDetailsPopupOpen,
    isPaymentClearancePopupOpen,
  } = useSelector((state: any) => state.invoices);

  const ConsolidatedInvoiceHandler = (): void => {
    //validate on selected first
    if (invoices.selectedItems && invoices.selectedItems.length == 0) {
      toast.error(t("selectValidation"));
    } else {
      dispatch(createConsolidatedInvoice() as any).then(
        (consolidatedInvoice: any) => {
          // console.log({consolidatedInvoice})
          // debugger
          if (consolidatedInvoice?.consolidatedInvoiceNumber) {
            toast.success(
              t("consolidatedInvoiceCreated", {
                invoiceNumber: consolidatedInvoice?.consolidatedInvoiceNumber,
              })
            );
            navigate(
              `${RoutePaths.ViewConsolidatedInvoiceDetails}?consolidatedInvoiceId=${consolidatedInvoice?.consolidatedInvoiceId}`
            );
          }
        }
      );
    }
  };
  const AddToConsolidatedInvoiceHandler = (): void => {
    dispatch(setIsAddToConsolidatedInvoicePopupOpen(true) as any);
  };
  const getClearanceRequestHandler = (): void => {
    dispatch(getPaymentClearance() as any);
  };
  const handleTabChange = (e: any) => {
    dispatch(setActiveTab(e.index));
    const numberOfRows = NUMBER_OF_ROWS_PER_PAGE;
    dispatch(setNumberOfRowsPerPage(numberOfRows));
    goToGridFirstPage();
  };
  const goToGridFirstPage = useCallback(() => {
    if (activeTab === 0) {
      dispatch(setGridCurrentPageInvoice(0));
    } else if (activeTab === 1) {
      dispatch(setGridCurrentPageConsolidatedInvoice(0));
    }
  }, []);

  const onPageLeave = useCallback(() => {
    dispatch(resetFilterData());
    dispatch(resetConsolidatedFilterData());
    dispatch(setInvoices({ data: [], totalRecords: 0 }));
    dispatch(setConsolidatedInvoices({ data: [], totalRecords: 0 }));
  }, []);

  useOnPageLeave(onPageLeave);

  useEffect(() => {
    dispatch(setSelectedItems([]));
    dispatch(getInvoiceStatusOptions() as any);
    dispatch(getBuildingsForInvoices() as any);
  }, [dispatch]);
  const items = [
    { label: t("invoices") },
    { label: t("consolidatedInvoices") },
  ];

  const handleFormFieldChange = (e: any) => {
    const name = e.target.name;
    const value = e.target.checked;
    if (activeTab === 0) {
      dispatch(setFilterDataField({ field: name, value }));
    } else {
      dispatch(setConsolidatedFilterDataField({ field: name, value }));
    }
  };

  useEffect(() => {
    dispatch(setGridCurrentPageInvoice(0));
  }, [dispatch]);

  useEffect(() => {
    if (showHistoricalDataChangeSource === "") return;
    const index = parseInt(showHistoricalDataChangeSource.toString());
    if (index >= 10)
      //the number that we set in the ShowHistoricalData component
      dispatch(setGridCurrentPageInvoice(0));
    dispatch(setChangeHistoricalDataSource(""));
  }, [showHistoricalDataChangeSource]);

  useEffect(() => {
    if (allConsolidatedInvoices.length) return;
    dispatch(getAllConsolidatedInvoices() as any).then(
      (response: { data: { ConsolidatedInvoiceIds: any[] } }) => {
        setAllConsolidatedInvoices(
          toCamel(response.data.ConsolidatedInvoiceIds)
        );
      }
    );
  }, []);

  const shouldShowAddToConsolidatedInvoiceButton = useMemo(() => {
    return allConsolidatedInvoices.length > 0;
  }, [allConsolidatedInvoices]);

  return (
    <div className="">
      <div className="d-flex justify-content-end mx-3 invoices-historical-data">
        <ShowHistoricalData
          handleFormFieldChange={handleFormFieldChange}
          showHistoricalData={showHistoricalData}
        />
      </div>
      <TabMenu
        model={items}
        activeIndex={activeTab}
        onTabChange={handleTabChange}
      />
      <Box sx={{ padding: 2 }}>
        {activeTab === 0 && (
          <div>
            <InvoicesFilter />
            <HorizontalDivider />
            <div className="px-3">
              <div className="d-flex py-3 justify-content-end invoice-action-buttons h-100">
                <div className="d-flex flex-wrap gap-2 align-items-center h-100">
                  {shouldShowAddToConsolidatedInvoiceButton && (
                    <Button
                      label={t("addToConsolidatedInvoice")}
                      className="edit-btn primary-btn m-0"
                      onClick={AddToConsolidatedInvoiceHandler}
                      icon={<Add className="m-0" />}
                      disabled={invoices.selectedItems.length === 0}
                    />
                  )}
                  <VerticalDivider />
                  <Button
                    label={t("createConsolidatedInvoice")}
                    className="edit-btn primary-btn m-0"
                    onClick={ConsolidatedInvoiceHandler}
                    icon={<Payments className="m-0" />}
                    disabled={invoices.selectedItems.length < 2}
                  />
                  <VerticalDivider />
                  <Button
                    className="edit-btn primary-btn m-0"
                    label={t("getClearanceRequest")}
                    icon={<ArticleShortcut className="m-0" />}
                    onClick={getClearanceRequestHandler}
                  ></Button>
                </div>
              </div>
            </div>

            <HorizontalDivider />

            <InvoicesGrid />
          </div>
        )}
        {activeTab === 1 && <ConsolidatedInvoicesGrid />}
      </Box>
      {isAddToConsolidatedInvoicePopupOpen && <AddToConsolidatedInvoicePopup />}
      {isInvoicesDetailsPopupOpen && <InvoicesDetailsPopup />}
      {isPaymentClearancePopupOpen && <PaymentClearancePopup />}
    </div>
  );
};

export default Invoices;
